import { LoadingSpinner, ErrorMessage } from '../../common';
import { useUserProfile } from '../hooks';
import {
  ProfileHeader,
  TokenUsageCard,
  WeeklyUsageCard,
  StatsCards,
  RecentActivity,
  PersonalInfoCard,
  SecurityCard,
} from '../ui';
import { LOADING_MESSAGES } from '../constants';

/**
 * ProfilePage - Página de perfil do usuário
 *
 * Exibe dashboard de uso, dados pessoais e configurações de segurança
 * Migrado para Tailwind CSS v4
 */
export const ProfilePage = () => {
  const { user, loading, error } = useUserProfile();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#242424] text-white flex flex-col items-center justify-center px-4 pt-[calc(var(--tais-header-height)+2rem)]">
        <LoadingSpinner size="large" />
        <div className="mt-4 text-[#CCCCCC] m-0">{LOADING_MESSAGES.fetchingProfile}</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#242424] text-white flex flex-col items-center justify-center px-4 pt-[calc(var(--tais-header-height)+2rem)]">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-[#242424] text-white px-4 md:px-6 lg:px-8 pt-[calc(var(--tais-header-height)+0.5rem)] pb-12">
      <div className="max-w-7xl mx-auto">
        {/* Profile Header */}
        <ProfileHeader user={user} />

        {/* Dashboard Section */}
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-6">
            <svg className="w-5 h-5 text-[#F4CC04]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            <div className="text-2xl font-bold text-white m-0">Dashboard de Uso</div>
          </div>

          {/* Usage Cards Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <TokenUsageCard />
            <WeeklyUsageCard />
          </div>

          {/* Stats Cards */}
          <StatsCards user={user} />

          {/* Recent Activity */}
          <RecentActivity />
        </div>

        {/* Personal Info & Security Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Personal Info */}
          <PersonalInfoCard user={user} />

          {/* Security */}
          <SecurityCard />
        </div>
      </div>
    </div>
  );
};
